/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartialGroup } from './PartialGroup';
import {
    PartialGroupFromJSON,
    PartialGroupFromJSONTyped,
    PartialGroupToJSON,
} from './PartialGroup';
import type { PlatformAccess } from './PlatformAccess';
import {
    PlatformAccessFromJSON,
    PlatformAccessFromJSONTyped,
    PlatformAccessToJSON,
} from './PlatformAccess';

/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    totalAgents?: number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    editorName?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    applicationType?: string;
    /**
     * 
     * @type {PlatformAccess}
     * @memberof Group
     */
    platformAccess?: PlatformAccess;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    welcomeScreen?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    holdReservation?: string;
}

/**
 * Check if a given object implements the Group interface.
 */
export function instanceOfGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function GroupFromJSON(json: any): Group {
    return GroupFromJSONTyped(json, false);
}

export function GroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): Group {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'totalAgents': !exists(json, 'totalAgents') ? undefined : json['totalAgents'],
        'editorName': !exists(json, 'editorName') ? undefined : json['editorName'],
        'applicationType': !exists(json, 'applicationType') ? undefined : json['applicationType'],
        'platformAccess': !exists(json, 'platformAccess') ? undefined : PlatformAccessFromJSON(json['platformAccess']),
        'welcomeScreen': !exists(json, 'welcomeScreen') ? undefined : json['welcomeScreen'],
        'holdReservation': !exists(json, 'holdReservation') ? undefined : json['holdReservation'],
    };
}

export function GroupToJSON(value?: Group | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'totalAgents': value.totalAgents,
        'editorName': value.editorName,
        'applicationType': value.applicationType,
        'platformAccess': PlatformAccessToJSON(value.platformAccess),
        'welcomeScreen': value.welcomeScreen,
        'holdReservation': value.holdReservation,
    };
}

